module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/hipercard-02684e4056e2ec1b541e8c2fcdc5e783.svg";